import { useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { CrossIcon } from 'Icons'

type ModalProps = {
  children: React.ReactNode
  isOpen: boolean
  onClose: () => void
}

export default function Modal({ isOpen, children, onClose }: ModalProps) {
  const intl = useIntl()

  if (!isOpen) return null

  const closeLabel = intl.formatMessage({ id: 'buttons.close', defaultMessage: 'Close' })

  return (
    <CloseOnKeyboard onClose={onClose}>
      <dialog
        className="absolute top-0 right-0 left-0 z-40 flex min-h-full w-full flex-col justify-start bg-black/50 py-6"
        onClick={onClose}
      >
        <div
          className="rounded-box bg-base-100 relative p-6 shadow-xl"
          onClick={(e) => e.stopPropagation()}
        >
          {children}
          <div className="mt-4 flex justify-end gap-2">
            <button
              className="btn btn-sm btn-circle btn-ghost absolute top-2 right-2"
              title={closeLabel}
              aria-label={closeLabel}
              onClick={onClose}
            >
              <CrossIcon />
            </button>
            <button className="btn" onClick={onClose}>
              <FormattedMessage id="buttons.ok" defaultMessage="OK" />
            </button>
          </div>
        </div>
      </dialog>
    </CloseOnKeyboard>
  )
}

function CloseOnKeyboard({
  onClose,
  children,
}: {
  onClose: () => void
  children: React.ReactNode
}) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' || e.key === 'Enter') {
        onClose()
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onClose])

  return children
}
